import React, { Component } from 'react'
import HeaderLine from '../../components/headerLine/headerLine'
import FormContainer from '../../components/formContainer/formContainer'
import { TextInput,  ImageUploadInput, SingleCheckBoxInput } from '../../components/input/inputModule'
import { getDuzenleData } from '../helpers/componentApiHelpers/getDuzenleData'
import { sendDataJson, changeDataJson } from '../helpers/componentApiHelpers/sendData'
import { getIdFromUrl } from '../helpers/getIdFromUrl'
import { getCall } from '../helpers/componentApiHelpers/getCall'

class BoyutlarEnter extends Component {

    constructor(props) {
        super(props)
        this.state = {
            sizeName: "",
            size: "",
            dataCame: false
        }
        this.onValChange = this.onValChange.bind(this)
    }

    async componentDidMount() {
        await getDuzenleData(2, "size", this)
    }

    async onValChange(e, stateProp) {
        e.preventDefault()
        await this.setState({ [stateProp]: e.target.value })
    }

    async send() {
        if (this.state.id === "" || this.state.id === undefined) {
            await sendDataJson("/size", "/boyutlar", this)
        } else {
            await changeDataJson("/size/", "/boyutlar", this)
        }
    }

    render() {
        return (
            <React.Fragment>
                <HeaderLine header="Ekle" />
                <FormContainer
                    sending={this.state.sending}
                    dataCame={getIdFromUrl(this.props.history.location.pathname, 2) !== undefined && !this.state.dataCame}
                >
                    <p className="main-paragraph">Boyut</p>
                    <TextInput ref="sizeName" label="Boyut Açıklaması" value={this.state.sizeName} stateProp="sizeName" onChange={this.onValChange} />
                    <TextInput ref="size" label="Boyut" value={this.state.size} stateProp="size" onChange={this.onValChange} />

                    {this.state.errorMessage && <p style={{ color: "red" }}>{this.state.errorMessage}</p>}
                    <button onClick={() => this.send()} className="save-button">Ekle</button>
                </FormContainer>
            </React.Fragment>
        )
    }
}

export default BoyutlarEnter